import Store from 'store/store';
import { accessNested } from 'utils/utils';

function $(selector) {
	return document.querySelector(selector);
}

let resizeObserver;
let cookieHeight;

if (typeof window !== 'undefined' && window.ResizeObserver) {
	if (window.ResizeObserver) {
		resizeObserver = new ResizeObserver(entries => {
			cookieHeight = entries[0].contentRect.height;
			updateCookieBanner(cookieHeight);
		});
	}
	lookForCookieBanner();
}

function lookForCookieBanner() {
	let start = Date.now();
	let check = () => {
		if ($('#_evidon_banner') && $('#_evidon_banner').offsetHeight) {
			if (resizeObserver) {
				return resizeObserver.observe($('#_evidon_banner'));
			}

			return setTimeout(() => updateCookieBanner($('#_evidon_banner').offsetHeight), 800);
		}
		if ($('#onetrust-banner-sdk') && $('#onetrust-banner-sdk').offsetHeight) {
			if (resizeObserver) {
				return resizeObserver.observe($('#onetrust-banner-sdk'));
			}

			return setTimeout(() => updateCookieBanner($('#onetrust-banner-sdk').offsetHeight), 800);
		}

		// After 20 seconds, give up
		if (Date.now() - start < 20000) {
			setTimeout(check, 100);
		}
	};
	check();
}

function updateCookieBanner(height) {
	const store = Store.get();
	const evidonPushDown = accessNested(store, 'appData.options.requireUserConsent.position', '') === 'pushdown';
	const oneTrustPushDown = accessNested(store, 'appData.options.oneTrustCookieConsent.position', '') === 'pushdown';

	if (!evidonPushDown && !oneTrustPushDown) {
		return;
	}

	const bannerContainer = document.createElement('div');
	bannerContainer.style.position = 'fixed';
	bannerContainer.style.top = 0;
	bannerContainer.style.width = '100%';
	bannerContainer.style.zIndex = 2147000001;
	document.body.insertBefore(bannerContainer, document.body.firstChild);

	if ($('#_evidon_banner')) {
		bannerContainer.appendChild($('#_evidon_banner'));
	} else if ($('#onetrust-consent-sdk')) {
		bannerContainer.appendChild($('#onetrust-consent-sdk'));
	}

	Store.get().set({
		externalCookieBanner: {
			bannerOpen: height > 0,
			height: height
		}
	});
}

